'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('./Button.styled');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var HeaderButton = function HeaderButton(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ['children', 'onClick', 'disabled']);

  return _react2.default.createElement(
    _Button2.default,
    _extends({ onClick: onClick, disabled: disabled }, rest),
    children
  );
};

HeaderButton.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes2.default.node,
  onClick: _propTypes2.default.func,
  disabled: _propTypes2.default.bool
} : {};

exports.default = HeaderButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/HeaderButton/index.js
// module id = 480
// module chunks = 14